<template>
  <div>
    <el-dialog :visible.sync="showForm" width="75%" top="5%" :show-close="false">
      <div key="form" v-loading="isLoading" element-loading-text="Enviando os dados, aguarde...">
        <h2 style="margin-top: 0; margin-bottom: 0;">Assessoria Contábil</h2>
        <h4 style="margin-top: 5px;">Preencha o formulário para solicitação de orçamento referente a nossa assessoria</h4>

        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item>
            <el-col :span="form.socio ? 17 : 10">
              <el-form-item label="Nome" prop="nome">
                <el-input v-model="form.nome"></el-input>
              </el-form-item>
            </el-col>

            <el-col :offset="1" :span="6">
              <el-form-item prop="socio">
                <label class="el-form-item__label" style="width: 100%; text-align: left;">Você é Sócio?</label>
                <el-switch active-text="Sim" inactive-text="Não" active-color="#13ce66" inactive-color="#ff4949" v-model="form.socio" @change="cleanOutro">Sócio?</el-switch>
              </el-form-item>
            </el-col>

            <el-col :offset="1" :span="6" v-if="!form.socio">
              <el-form-item label="Outros" prop="outro">
                <el-input v-model="form.outro"  placeholder="Outro?"></el-input>
              </el-form-item>
            </el-col>

          </el-form-item>

          <el-form-item>
            <el-col :span="10">
              <el-form-item label="Email" prop="email">
                <el-input v-model="form.email" placeholder="Email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="6">
              <el-form-item label="Telefone Fixo" prop="telefone">
                <div class="el-input">
                  <input type="text" v-model="form.telefone" placeholder="(99) 9999-9999"  v-mask="'(99) 9999-9999'" class="el-input__inner" />
                </div>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="6">
              <el-form-item label="Celular" prop="celular">
                <div class="el-input">
                  <input type="text" v-model="form.celular" placeholder="(99) 99999-9999"  v-mask="'(99) 99999-9999'" class="el-input__inner" />
                </div>
              </el-form-item>
            </el-col>

          </el-form-item>

          <el-form-item>
            <el-col :span="12">
              <el-form-item label="Nome da Empresa" prop="nomeEmpresa">
                <el-input v-model="form.nomeEmpresa"></el-input>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="11">
              <el-form-item label="CNPJ da Empresa" prop="cnpjEmpresa">
                <div class="el-input">
                  <input type="text" v-model="form.cnpjEmpresa" placeholder="99.999.999/9999-99" v-mask="'99.999.999/9999-99'" class="el-input__inner" />
                </div>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="Ramo de Atuação" prop="ramoAtuacao">
            <el-input type="textarea" v-model="form.ramoAtuacao" :autosize="{ minRows: 1}"></el-input>
          </el-form-item>

          <el-form-item label="Faturamento médio da empresa" prop="faturamentoMedio">
            <div class="el-input el-input-group el-input-group--prepend">
              <div class="el-input-group__prepend">R$</div>
              <input type="text" v-model="form.faturamentoMedio" v-mask="'money'" autocomplete="off" class="el-input__inner" />
            </div>
          </el-form-item>

          <el-form-item>

            <el-col :span="12">

              <el-form-item prop="quantidadeFuncionarios">
                <label class="el-form-item__label" style="width: 100%; text-align: left;">Quantidade de funcionários</label>
                <el-input-number v-model="form.quantidadeFuncionarios" :min="0"></el-input-number>
              </el-form-item>

            </el-col>

            <el-col :offset="1" :span="11">

              <el-form-item prop="quantidadeNotasEmitidas">
                <label class="el-form-item__label" style="width: 100%; text-align: left;">Quantidade de notas emitidas no mês</label>
                <el-input-number v-model="form.quantidadeNotasEmitidas" :min="0"></el-input-number>
              </el-form-item>

            </el-col>

          </el-form-item>

          <el-form-item prop="adquireMercadoriasOutrosEstados">
            <label class="el-form-item__label" style="width: 100%; text-align: left;">Empresa adquire mercadorias para revenda e/ou consumo provenientes de outros estados?</label>
            <el-radio-group size="large" v-model="form.adquireMercadoriasOutrosEstados">
              <el-radio label="Sim" style="font-weight: normal;"></el-radio>
              <el-radio label="Não" style="font-weight: normal;"></el-radio>
              <el-radio label="Não sei" style="font-weight: normal;"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="atuaExportacaoImportacao">
            <label class="el-form-item__label" style="width: 100%; text-align: left;">Empresa atua com exportação ou importação de produtos?</label>
            <el-radio-group size="large" v-model="form.atuaExportacaoImportacao">
              <el-radio label="Sim" style="font-weight: normal;"></el-radio>
              <el-radio label="Não" style="font-weight: normal;"></el-radio>
              <el-radio label="Não sei" style="font-weight: normal;"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="possuiSoftwareGestao">
            <label class="el-form-item__label" style="width: 100%; text-align: left;">Empresa possui software de gestão?</label>
            <el-radio-group size="large" v-model="form.possuiSoftwareGestao">
              <el-radio label="Sim" style="font-weight: normal;"></el-radio>
              <el-radio label="Não" style="font-weight: normal;"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="possuiProfissionalAdministrativo">
            <label class="el-form-item__label" style="width: 100%; text-align: left;">Possui profissional administrativo dedicado - Contrato CLT?</label>
            <el-radio-group size="large" v-model="form.possuiProfissionalAdministrativo">
              <el-radio label="Sim" style="font-weight: normal;"></el-radio>
              <el-radio label="Não" style="font-weight: normal;"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="rotatividadeMensalFuncionarios">
            <label class="el-form-item__label" style="width: 100%; text-align: left;">Rotatividade mensal de funcionários (média de admissões + rescisões)</label>
            <el-input-number v-model="form.rotatividadeMensalFuncionarios" :min="0"></el-input-number>
          </el-form-item>
        </el-form>

        <vue-recaptcha :sitekey="sitekey" @verify="verifyRecaptcha" @expired="recaptchaExpired" ref="_recaptcha"></vue-recaptcha>
      </div>

      <div key="buttons" slot="footer" class="dialog-footer" v-if="!isLoading">
        <el-button :disabled="!isValid" @click.prevent="sendForm" type="success">Enviar</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import AwesomeMask from 'awesome-mask'

import { validaCnpj } from '../validators/cnpj.js'

export default {
  name: 'AssessoriaContabil',

  components: {
    VueRecaptcha
  },

  directives: {
    'mask': AwesomeMask
  },

  data () {
    return {
      sitekey: '6Ldv0esUAAAAAEfgh5OYk1RuQ3Is34jLR-HNL_G3',
      isLoading: false,
      isReseting: false,
      form: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        nome: '',
        socio: true,
        outro: '',
        email: '',
        telefone: '',
        celular: '',
        nomeEmpresa: '',
        cnpjEmpresa: '',
        ramoAtuacao: '',
        faturamentoMedio: '',
        quantidadeFuncionarios: 0,
        quantidadeNotasEmitidas: 0,
        adquireMercadoriasOutrosEstados: '',
        atuaExportacaoImportacao: '',
        possuiSoftwareGestao: '',
        possuiProfissionalAdministrativo: '',
        rotatividadeMensalFuncionarios: 0,
        _valid: false
      },
      newForm: {
        nome: 'Lorem Ipsum',
        socio: true,
        outro: '',
        email: 'lorem@ipsum.com',
        telefone: '(41) 3434-5592',
        celular: '(41) 98707-8479',
        nomeEmpresa: 'Lorem Ipsum Inc',
        cnpjEmpresa: '81.253.460/0001-23',
        ramoAtuacao: 'Mauris lacus ipsum, euismod ac aliquam in, pulvinar ac dolor. Maecenas fringilla, tortor eu tincidunt tempus, sapien lectus efficitur justo, eu congue ligula erat sit amet urna. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nec luctus ipsum. Proin in pretium nibh. Proin suscipit tempor risus, quis hendrerit enim viverra pellentesque. Quisque at sapien quis purus porttitor dignissim vitae ut ipsum.',
        faturamentoMedio: '99.999,99',
        quantidadeFuncionarios: 99,
        quantidadeNotasEmitidas: 999,
        adquireMercadoriasOutrosEstados: 'Sim',
        atuaExportacaoImportacao: 'Não sei',
        possuiSoftwareGestao: 'Não',
        possuiProfissionalAdministrativo: 'Sim',
        rotatividadeMensalFuncionarios: 9
      },
      rules: {
        nome: [
          { required: true, message: 'O nome é obrigatório', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'O email é obrigatório', trigger: 'blur' },
          { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }
        ],
        telefone: [
          { type: 'string', pattern: /\((10)|([1-9][1-9])\) [0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto: Ex. (99) 9999-9999', trigger: 'blur' }
        ],
        celular: [
          { required: true, message: 'Um número de celular é obrigatório', trigger: 'blur' },
          { type: 'string', pattern: /\((10)|([1-9][1-9])\) [9][0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um celular no formato correto: Ex. (99) 99999-9999', trigger: 'blur' }
        ],
        nomeEmpresa: [
          { required: true, message: 'O nome da empresa é obrigatório', trigger: 'blur' }
        ],
        cnpjEmpresa: [
          { required: true, message: 'O CNPJ da empresa é obrigatório', trigger: 'blur' },
          { validator: validaCnpj, trigger: 'blur' }
        ],
        ramoAtuacao: [
          { required: true, message: 'O ramo de atuação é obrigatório', trigger: 'blur' }
        ],
        faturamentoMedio: [
          { required: true, message: 'É obrigatório informar o faturamento médio da empresa', trigger: 'blur' }
        ],
        quantidadeFuncionarios: [
          { type: 'integer', required: true, message: 'É obrigatório informar a quantidade de funcionários', trigger: 'blur' }
        ],
        quantidadeNotasEmitidas: [
          { type: 'integer', required: true, message: 'É obrigatório informar a quantidade de notas emitidas no mês', trigger: 'blur' }
        ],
        adquireMercadoriasOutrosEstados: [
          { required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }
        ],
        atuaExportacaoImportacao: [
          { required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }
        ],
        possuiSoftwareGestao: [
          { required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }
        ],
        possuiProfissionalAdministrativo: [
          { required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }
        ],
        rotatividadeMensalFuncionarios: [
          { type: 'integer', required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'blur' }
        ]
      },
      showForm: false
    }
  },

  computed: {
    totalSteps () { return this.steps.length },

    isValid () { return this.form._valid && this.form._recaptcha._valid }
  },

  mounted () {
    this.$eventBus.$on('ASSESSORIA_CONTABIL', payload => {
      this.showForm = payload

      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      if (params.get('test') !== null) {
        Object.assign(this.$data.form, this.newForm)
      }
    })
  },

  watch: {
    form: {
      handler () {
        this.$nextTick(() => {
          if (!this.isReseting) {
            this.verifyValidation()
          } else {
            this.isReseting = false
          }
        })
      },
      deep: true
    }
  },

  methods: {
    cleanOutro () {
      this.form.outro = ''
    },

    sendForm () {
      this.isLoading = true

      if (this.isValid) {
        this.$http.post('https://cdn.icnex.com/formularios18/?assessoria-contabil', this.form, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Request-Methods': 'GET,POST'
          }
        })
          .then(response => {
            this.$message.success('Enviado com sucesso! Aguarde nosso contato')

            this.$nextTick(() => {
              this.backToBeginSetup()
            })
          })
          .catch(response => {
            this.$message.error('Houve um erro! Por favor tente novamente mais tarde ou entre em contato.')

            this.$nextTick(() => {
              this.backToBeginSetup()
            })
          })
      }
    },

    verifyRecaptcha (recaptcha) {
      this.form._recaptcha = {
        _response: recaptcha,
        _valid: true
      }
    },

    recaptchaExpired () {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' })

      this.form._recaptcha = {
        _response: '',
        _valid: false
      }
    },

    verifyValidation () {
      this.$refs.form
        .validate((valid) => {
          this.form._valid = valid

          return valid
        })
    },

    backToBeginSetup () {
      this.isReseting = true
      this.$refs._recaptcha.reset()
      this.$refs.form.resetFields()
      this.isLoading = false
      this.showForm = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConteudoAssessoriaContabil.vue?14a4eb70